import { FrequencyMode } from 'modules/frequencyManagement/lib/types';
import { INITIAL_MODE, MessageTypeSchema } from '../../contexts/FormProvider';
import { Filters } from '../../contexts/FiltersProvider';

const matchesIdOrNames = (field: MessageTypeSchema, search: string) => {
  const { id, name, channelName } = field;
  const term = search.toLowerCase();
  return (
    id.toString().includes(term) ||
    name?.toLowerCase().includes(term) ||
    channelName?.toLowerCase().includes(term)
  );
};

const matchesMode = (field: MessageTypeSchema, filters: Set<Filters>) => {
  /**
   * Filters work against the saved value for mode, rather than the current
   * value in the form state. This was added to avoid message types disappearing
   * from view when mode is updated.
   */
  const { [INITIAL_MODE]: initialMode } = field;

  if (initialMode === FrequencyMode.Off) return filters.has(Filters.IS_OFF);
  if (initialMode === FrequencyMode.NoCap) return filters.has(Filters.IS_NO_CAP);
  if (initialMode === FrequencyMode.Cap) return filters.has(Filters.IS_CAP);
  if (initialMode === FrequencyMode.Optimize) return filters.has(Filters.IS_OPTIMIZE);

  return false;
};

export const createFilterBySearchAndFilters = (search: string, filters: Set<Filters>) => {
  return (field: MessageTypeSchema) => {
    /** If search is present, must match search */
    if (search && !matchesIdOrNames(field, search)) return false;

    /** If filters are applied, must match filters */
    if (filters.size > 0 && !matchesMode(field, filters)) return false;

    return true;
  };
};
